<script setup lang="ts"></script>

<template>
  <p class="ml-2 text mt-1">
    <slot> </slot>
  </p>
</template>

<style scoped>
  .text {
    display: block;
    font-size: 14px;
    height: 36px;
    font-family: Roboto, sans-serif;
  }
</style>
